import React from 'react';
import { Link } from 'react-router-dom';
import { LockKey } from '@phosphor-icons/react';

/**
 * Lock-icon micro-badge shown in the global footer of every authenticated page.
 * Reassures the user during money-movement moments that SOC 2 controls are live.
 * Pure CSS, no runtime cost.
 */
export default function TrustBadge({ compact = false, className = '' }) {
  if (compact) {
    return (
      <Link
        to="/trust"
        data-testid="trust-badge-compact"
        className={`inline-flex items-center gap-1.5 text-[10px] tracking-[0.14em] uppercase font-bold text-[#22C55E]/80 hover:text-[#22C55E] transition-colors ${className}`}
      >
        <LockKey className="w-3 h-3" weight="duotone" />
        <span>SOC 2 controls active</span>
      </Link>
    );
  }
  return (
    <Link
      to="/trust"
      data-testid="trust-badge"
      className={`inline-flex items-center gap-2 bg-[#22C55E]/8 hover:bg-[#22C55E]/15 border border-[#22C55E]/20 hover:border-[#22C55E]/40 rounded-full px-3 py-1.5 transition-colors group ${className}`}
    >
      <LockKey className="w-3.5 h-3.5 text-[#22C55E]" weight="duotone" />
      <span className="text-[10px] tracking-[0.16em] uppercase font-bold text-[#22C55E]/90 group-hover:text-[#22C55E]">
        Verified by SOC 2 controls
      </span>
    </Link>
  );
}
